let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hoPjF")).then(() => parcelRequire('4welg'));